import type { DefaultTradeSettingsAttributes } from '@library/types/trading';

export const defaultTradeSettingAttributes: DefaultTradeSettingsAttributes = {
  demon: {
    minProbabilityOfMore: 0.2,
    maxProbabilityOfMore: 0.47,
    targetProbabilityOfMore: 0.3
  },
  goblin: {
    minProbabilityOfMore: 0.53,
    maxProbabilityOfMore: 0.8,
    targetProbabilityOfMore: 0.7
  },
  standard: {
    minProbabilityOfMore: 0.47,
    maxProbabilityOfMore: 0.53,
    targetProbabilityOfMore: 0.5
  }
};
